// extracted by mini-css-extract-plugin
export default {"wrapper":"adminuser_list_wrapper__k8wq-"};